import * as React from 'react';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired, isValidYearLength } from '../../../../../../util/validators';
import SelectControl from '../../../../../../components/SelectControl';

interface IVehicleDetailsProps {
    renderDefinition(name: string, defName?: string): any;
    channelKey: string;
}

class VehicleDetails extends React.Component<IVehicleDetailsProps, any> {

    public render() {
        const { renderDefinition, channelKey } = this.props;

        if (!['eurp-b2c'].includes(channelKey)) {
            return null;
        }

        return (
            <div className="section">
                <FormGroup controlId="vehicle_details">
                    <Row>
                        <Col sm={12} md={12} style={{ paddingLeft: '0', paddingRight: '0', marginBottom: '10px' }}>
                            <div>
                                <h3 id="vehicle_details">
                                    Vehicle Details {renderDefinition('vehicle_details')}
                                </h3>
                            </div>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="make">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Make:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="make"
                                type="input"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="model">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Model:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="model"
                                type="input"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="type">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Type:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="type"
                                type="select"
                                options={[
                                    {label: 'Car / LPG (including estates and SUVs)', value: 'Car/LPG/Estate/SUV'},
                                    {label: 'Motorcycle', value: 'Motorcycle'},
                                    {label: 'Light Commercial Less 3.5T', value: 'Light Commercial Less 3.5T'},
                                    {label: 'Motorhome under 3.5t', value: 'Motorhome under 3.5t'},
                                    {label: 'Campervan', value: 'Campervan'},
                                    {label: 'Minibus', value: 'Minibus'},
                                ]}
                                component={SelectControl}
                                clearable={false}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="year">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Year:
                            </ControlLabel>
                        </Col>
                        <Col sm={3}>
                            <Field
                                name="year"
                                type="number"
                                component={FieldFormControl}
                                validate={[isValidYearLength]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="value">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Value:
                            </ControlLabel>
                        </Col>
                        <Col sm={3}>
                            <Field
                                name="value"
                                type="input"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="colour">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Colour:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="colour"
                                type="input"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="transType">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Trans type:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="transType"
                                type="select"
                                options={[
                                    {label: 'Manual', value: 'M'},
                                    {label: 'Automatic', value: 'A'},
                                ]}
                                component={SelectControl}
                                clearable={false}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="fuelType">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                Fuel type:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="fuelType"
                                type="select"
                                options={[
                                    {label: 'Petrol', value: 'P'},
                                    {label: 'Diesel', value: 'D'},
                                    {label: 'LPG', value: 'LPG'},
                                ]}
                                component={SelectControl}
                                clearable={false}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup controlId="fourByFourDrive">
                    <Row>
                        <Col sm={3}>
                            <ControlLabel>
                                4x4 Drive:
                            </ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Field
                                name="fourByFourDrive"
                                type="select"
                                options={[
                                    {label: 'Yes', value: 'Y'},
                                    {label: 'No', value: 'N'},
                                ]}
                                component={SelectControl}
                                clearable={false}
                                validate={[isRequired]}
                            />
                        </Col>
                    </Row>
                </FormGroup>
            </div>
        );
    }
}

export default VehicleDetails;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/AdditionalCover/components/VehicleDetails/index.tsx